import { AbstractAction } from "../switchless-redux-actions";
import requestApi from "../helpers/fetcher";
import { store } from "../store";

/**
 * @constructor UndoAction
 *
 * @abstract
 *
 * @extends AbstractAction
 * @param {Object} params - Params object
 * @param {*} params.payload - Action payload
 * @param {*} params.meta - Action payload
 * @param {Object} [my] - Protected properties holder
 */
export class UndoAction extends AbstractAction {
	type = "Undo";

	performUndoReducer(state) {
		let action = state.lastAction.undo();
		if (action.isRequestAction) {
			requestApi(action);
		} else {
			store.dispatch(action);
		}

		return {
			canRedo: true,
			canUndo: false
		};
	}
}

/**
 * @constructor RedoAction
 *
 * @extends AbstractAction
 */
export class RedoAction extends AbstractAction {
	type = "Redo";

	performUndoReducer(state) {
		let action = state.lastAction.redo();

		if (action.isRequestAction) {
			requestApi(action);
		} else {
			store.dispatch(action);
		}

		return {
			canUndo: true,
			canRedo: false
		};
	}
}
